export type HttpHeader = {
  name: string;
  value: string;
};

const convertToStringMap = (headers?: HttpHeader[]): [string, string][] =>
  headers == undefined
    ? []
    : headers.map(header => [header.name, header.value]);

const sendGet = (url: string, headers: HttpHeader[], validStatusCodes: number[]) => {
  return new Promise<any>((resolve, reject) => fetch(url, { headers: convertToStringMap(headers) })
    .then(response => {
      const statusCode = response.status;
      if (statusCode === 200) {
        response.json()
          .then(resolve)
          .catch(reason => reject(`Could not get json from url [${url}] GET response [${response}]: ${reason}`));
      } else {
        if (!validStatusCodes.includes(statusCode)) {
          alert(`Error HTTP/${statusCode}`);
        }
        reject(response);
      }
    })
    .catch(reason => reject(`Could not fetch response from url [${url}]: ${reason}`)));
};

const send = (
  url: string,
  method: 'PUT'|'POST'|'PATCH',
  data: any,
  additionalHeaders: HttpHeader[]
) => {
  const headers = convertToStringMap(additionalHeaders);
  return new Promise<any>((resolve, reject) => fetch(url, {
    method: method,
    headers: [
      ...headers,
      ['Content-Type', 'application/json']
    ],
    body: JSON.stringify(data)
  }).then(response => {
    const statusCode = response.status;
    if (statusCode === 200) {
      response.json()
        .then(resolve)
        .catch(reason => reject(`Could not get json from url [${url}] ${method} response [${response}]: ${reason}`));
      } else {
        alert(`Error HTTP/${statusCode}`);
        reject(response);
      }
    })
    .catch(reason => reject(`Could not ${method} response to url [${url}]: ${reason}`)));
};

const postForFile = (url: string, method: 'POST', data: any) => {
  return new Promise<any>((resolve, reject) => fetch(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(resolve)
    .catch(reason => reject(`Could not ${method} response to url [${url}]: ${reason}`)));
};

const sendDelete = (
  url: string,
  headers: HttpHeader[]
) => {
  return new Promise<any>((resolve, reject) => fetch(url, {
      method: 'DELETE',
      headers: convertToStringMap(headers)
    })
    .then(response => {
      const responseStatusCode = response.status;
      console.debug(`Delete status code: ${responseStatusCode}`);
      if (responseStatusCode === 500 || responseStatusCode === 400) {
        response.json()
          .then(reject)
          .catch(() => reject(`Got ${responseStatusCode} from url [${url}] DELETE response [${response}]`));
      } else {
        response.json()
          .then(resolve)
          .catch(reason => reject(`Could not get json from url [${url}] DELETE response [${response}]: ${reason}`))
      }
    })
    .catch(reason => reject(`Could not process DELETE with url [${url}]: ${reason}`)));
};

export default {
  delete: sendDelete,
  get: (url: string, headers: HttpHeader[], validStatusCodes?: number[]) => sendGet(url, headers, validStatusCodes || [200]),
  patch: (url: string, data: any, headers: HttpHeader[]) => send(url, 'PATCH', data, headers === undefined ? [] : headers),
  post: (url: string, data: any, headers: HttpHeader[]) => send(url, 'POST', data, headers === undefined ? [] : headers),
  put: (url: string, data: any, headers: HttpHeader[]) => send(url, 'PUT', data, headers === undefined ? [] : headers),
  postForFile: (url: string, data: any) => postForFile(url, 'POST', data),
}